export default {"betButton":"WnGCC"};